import React, { Component } from 'react';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { createStore, applyMiddleware } from 'redux';
import { reducers } from './config/reduxIndex';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import Router from './config/Router';

let middleware = [
	thunk
]

const composeStoreWithMiddleware = applyMiddleware(
	...middleware
)(createStore);
let store = composeStoreWithMiddleware(reducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
window.store = store;


class App extends Component {
	render() {
		return <Provider store={store}>
			<Router />
		</Provider>
	}
}

export default DragDropContext(HTML5Backend)(App);


// WEBPACK FOOTER //
// ./src/App.js